import { create } from 'zustand';
import { clockNow, useClock, useUI } from '@/state/store';
import type { ContactWindow } from '../types';

export interface PassSelection extends ContactWindow {
  missionId: string;
  antennaId: string;
}
export const usePass = create<{
  selected: PassSelection | null;
  replaying: boolean;
  select: (pass: PassSelection | null) => void;
  replay: () => void;
}>()((set, get) => ({
  selected: null,
  replaying: false,
  select: (selected) => {
    set({ selected, replaying: false });
    if (selected)
      useUI
        .getState()
        .select({ missionId: selected.missionId, antennaId: selected.antennaId, assetId: null });
  },
  replay: () => {
    const pass = get().selected;
    if (!pass) return;
    useClock.setState({ live: false, simTime: pass.startMs - 30_000, multiplier: 10, playing: true });
    set({ replaying: true });
  },
}));

export function passPhase(
  pass: ContactWindow,
  nowMs = clockNow(),
): 'Approach' | 'In pass' | 'Loss of signal' {
  return nowMs < pass.startMs ? 'Approach' : nowMs < pass.endMs ? 'In pass' : 'Loss of signal';
}
